import { StoreModel } from '@/store/models/StoreModel'
import { AddressTypeEnum } from '@c2b/commons';
import { OrderStatusEnum, getOrderStatusEnumDescription } from '@c2b/muven-commons'
import { cloneDeep } from 'lodash';
import { ChannelModel } from '../../channel/models/ChannelModel';
import { OrderFakeAddressModel } from './OrderFakeAddressModel';
import { OrderFakeInvoiceModel } from './OrderFakeInvoiceModel';

interface StatusWrapper {
    enum: OrderStatusEnum,
    description: string,
}

interface FakeItemInfo {
    productIdOnSeller: string;
    quantity: number;
    unitPrice: number;
    discount?: number;
    increment?: number;
    isGift?: boolean;
}

export class OrderFakeModel {
    static normalizeBeforeSubmit(orderFake: OrderFakeModel):OrderFakeModel {
        const tmpOrder = cloneDeep(orderFake)

        if (
            !tmpOrder.invoice?.number && 
            !tmpOrder.invoice?.serie && 
            !tmpOrder.invoice?.key && 
            !tmpOrder.invoice?.xml &&
            !tmpOrder.invoice?.shippingEstimateDate &&
            !tmpOrder.invoice?.shippingEstimateDays
        ) {
            tmpOrder.invoice = null
        } else {        
            tmpOrder.invoice = {
                number: tmpOrder.invoice?.number || 1,
                serie: tmpOrder.invoice?.serie || null,
                key: tmpOrder.invoice?.key || null,
                xml: tmpOrder.invoice?.xml || null,
                shippingEstimateDate: tmpOrder.invoice?.shippingEstimateDate || null,
                shippingEstimateDays: tmpOrder.invoice?.shippingEstimateDays || null,
            }
        }

        if (tmpOrder.preferToSelectItems) {
            tmpOrder.nrRandomItens = 0

            tmpOrder.items = (tmpOrder.items || []).map((item: FakeItemInfo) => {
                return {
                    ...item,
                    unitPrice: Number(item.unitPrice) || 0,
                    quantity: Number(item.quantity) || 0,
                    discount: Number(item.discount) || 0,
                    increment: Number(item.increment) || 0,
                    isGift: item.isGift === true,
                } as FakeItemInfo
            })
        }

        tmpOrder.deliveryCompanyId = tmpOrder.deliveryCompanyId || null;
        tmpOrder.paymentId = tmpOrder.paymentId || null;

        return tmpOrder
    }

    statusWrapper: StatusWrapper = {
        enum: OrderStatusEnum.Approved,
        description: getOrderStatusEnumDescription(OrderStatusEnum.Approved),
    };
    status: OrderStatusEnum = OrderStatusEnum.Approved;
    cpfCnpj: string = ""
    billingAddress: OrderFakeAddressModel = new OrderFakeAddressModel()
    deliveryAddress: OrderFakeAddressModel = new OrderFakeAddressModel()
    email: string = ""
    phone: string = ""
    idChannel: string = ""
    channel: ChannelModel = new ChannelModel()
    items: FakeItemInfo[] = []
    stateInscription:string = ""
    nrRandomItens: number = 3
    discountValue: number = 0
    incrementValue: number = 0
    freightTotal: number = 99
    installments: number = 1
    shippingEstimateDays: number = 5
    nsuCode: string = ""
    store: StoreModel = new StoreModel()
    storeSellerId: string = ""    
    documentPaymentGateway: string = ""
    documentMarketplace: string = ""
    storeNameMarketplace: string = ""
    invoice: OrderFakeInvoiceModel|null = new OrderFakeInvoiceModel()    
    preferToSelectItems: boolean = false
    sellerNotes: string = "";
    customerNotes: string = "";
    deliveryCompanyId: string|null = "";
    paymentId: string|null = "";

    copyDeliveryAddressIntoBillingAddress():void {
        for (const key in this.deliveryAddress) {
            if (key) {
                // @ts-ignore
                this.billingAddress[key] = this.deliveryAddress[key];
            }
        }
    }

    updateItemsChoice(b:boolean):void {
        this.preferToSelectItems = b
    }

    addItem(item: FakeItemInfo):void {
        this.items.push(cloneDeep(item))
    }

    removeItem(itemPos:number):void {
        this.items.splice(itemPos, 1)
    }

    clearItems():void {
        this.items = []
    }

    setStore(store: StoreModel):void {
        this.store = store
        this.storeSellerId = store.idSource as string
    }

    setChannel(channel: ChannelModel):void {
        this.channel = channel
        this.idChannel = channel.id as string
    }

    setStatus(statusWrapper: StatusWrapper):void {
        this.status = statusWrapper.enum
    }

    isValid():boolean {
        if (this.preferToSelectItems) {
            if (!this.items.length) {
                return false;
            }
        } else {
            if (!this.nrRandomItens) {
                return false
            }
        }
        
        return !!this.storeSellerId && 
               // @ts-ignore
               typeof this.status !== 'undefined' &&
               this.nrRandomItens > 0 && this.nrRandomItens <= 10
    }

    hasItems():boolean {
        if (!Array.isArray(this.items)) {
            return false
        }

        return this.items.length > 0
    }
}
